module.exports = __webpack_public_path__ + "static/media/arrow.fb0b45cb.svg";